import { Button, ButtonProps } from '@fable/components'
import { useTheme } from '@fable/theme'
import {
  ClubDetailJoinButtonContextProvider,
  useClubDetailJoinButton,
} from 'app/clubs/hooks'

/**
 * @note
 * exported for testing
 * use ClubDetaiJoinButton below
 */
export const ClubDetailJoinButtonContent = (props: ButtonProps) => {
  const { colors, mediaQueries } = useTheme()

  const { title, handleClick, shouldDisableButton, isInvite, loading } =
    useClubDetailJoinButton()

  return (
    <Button
      dataTestId={isInvite ? 'join-button-for-invite' : 'join-button'}
      label={title}
      custom={{
        display: 'block',
        marginTop: '24px',
        padding: '0 20px',
        width: '100%',
        backgroundColor: colors.graphite,
        borderColor: colors.graphite,
        [mediaQueries.tabletL]: {
          marginTop: '24px',
          width: 'auto',
        },
      }}
      loading={loading}
      onClick={handleClick}
      disabled={shouldDisableButton}
      {...props}
    />
  )
}

export const ClubDetailJoinButton = (props: ButtonProps) => (
  <ClubDetailJoinButtonContextProvider>
    <ClubDetailJoinButtonContent {...props} />
  </ClubDetailJoinButtonContextProvider>
)
